import {hamburgerNavTemplate} from "./templates/hamburger-nav.js";
import {subCategoryNavTemplate} from "./templates/subcat-wrap.js";
import {hamSubCategoryNavTemplate} from "./templates/ham-subcat-wrap.js";
import {subCategoryItemTemplate} from "./templates/subcat-item.js";
import {basicModalTemplate} from "../../common_assets/templates/dialog.js";
import {loginTemplate} from "./templates/login.js";
import {loginRegistrationFunctionality} from "./login.js";
import "./registration.css";
import "./header-dropdown.css";

//const menuCategoriesDataUrl = 'https://gong2025.ni.bg:4433/carousell/menu_categories';
//const menuCategoriesDataUrl = 'https://gong2025.ni.bg:4433/webpack/src/components/header/data/menu_categories.json';

if (menuCategoriesDataUrl === 'undefined') {
    const menuCategoriesDataUrl = '';
}

(async () => {
  try {
    // Access the global `lscrUrl` variable set by PHP
    //const menuCategoriesDataUrl = 'https://gong2025.ni.bg:4433/carousell/menu_categories';

    // Fetch the JSON data from the URL
    const response = await fetch(menuCategoriesDataUrl);

    if (!response.ok) {
      throw new Error(`Failed to fetch data: ${response.statusText}`);
    }

    // Parse the JSON response
    const data = await response.json();
    //console.log('Fetched Data:', data);

    // Use the data in your component
    loadMenuCatgoriesData(data);
    
  } catch (error) {
    console.error('Error fetching data:', error);
  }
})();

//console.log('HEADER SUBCAT LOOAAAADED 1 !!!!!!!!!!!!============================');

//        $('body').on('touchstart', '#hamburger a', function (e) {
//        console.log('#hamburger a touchstarted!!!! passive: false');
//        e.preventDefault();
//        });
//jQuery .on() does not support { passive: false }, which means preventDefault does not work,
// so we use addEventListener directly    
document.body.addEventListener('touchstart', function(e) {
    console.log('#hamburger a touchstarted!!!! passive: false, vanilla js');
    const link = e.target.closest('#hamburger .ham-sports-nav .ham-drop-wrap.closed > a');
    if (!link) return;
    if (e.cancelable) e.preventDefault();
}, { passive: false });

function loadMenuCatgoriesData(data){
    //console.log('loadMenuCatgoriesData data', data);
    let listedCategories = [];
    let categoriesLength = Object.keys(data).length - 1;
    //subcategories dropdowns init
    $('header .sports-nav > a:not(.head-nav-trgr)').each(function (item) {
        //console.log(item + ": " + $(this).text());
        $(this).addClass('head-nav-trgr closed').wrap('<div class="head-drop-wrap closed" ></div>');
        let categoryId = $(this).attr('data-id');
        
        if (categoryId != 'more-categories') {
            $(this).closest('.head-drop-wrap').append(subCategoryNavTemplate(categoryId));
            listedCategories.push(parseInt(categoryId));
            //console.log('numeral car, listedCategories = ', listedCategories);
            for (let i = 0; i < data[categoryId].subcategories.length; i++){
                let itemElement = subCategoryItemTemplate('sub-category', 
                                    data[categoryId].subcategories[i].img_src, 
                                    data[categoryId].subcategories[i].item_title,
                                    data[categoryId].subcategories[i].href,
                                    ''
                                    );
                $('#' + categoryId).append(itemElement);                
            }
        } else {
            $(this).closest('.head-drop-wrap').append(subCategoryNavTemplate('more-categories'));
            
            //Print the rest categories in ... subnav
            for (let i = 0; i < categoriesLength; i++){
                if (data[i].item_title != 'Още спорт') {                    
                    if( !listedCategories.includes(i) ){
                        let itemMoreCategoriesElement = subCategoryItemTemplate('category',
                                                        data[i].img_src,
                                                        data[i].item_title,
                                                        data[i].href,
                                                        i
                                                        );
                        $('#' + categoryId).append(itemMoreCategoriesElement);
                    };            
                } else {
                    //Print all subcategories from Още спорт after the categories in ... subnav
                    for (let j = 0; j < data[i].subcategories.length; j++){                        
                        let itemMoreSportElement = subCategoryItemTemplate('category',
                                                    data[i].subcategories[j].img_src,
                                                    data[i].subcategories[j].item_title,
                                                    data[i].subcategories[j].href,
                                                    i
                                                    );
                        $('#' + categoryId).append(itemMoreSportElement);
                    }
                };
            };            
        };
    });
    
    
    //hamburger menu load
    $('header .hamburger-nav-element').closest('.head-drop-wrap').append(hamburgerNavTemplate());
    
    for (let i = 0; i < categoriesLength; i++) {
        let itemCategoriesElement = subCategoryItemTemplate('category',
                data[i].img_src,
                data[i].item_title,
                data[i].href,
                'ham-' + i
                );
        $('.ham-sports-nav').append('<div class="ham-drop-wrap closed" >' + itemCategoriesElement + '</div>');
        
        let itemSubCategoriesNavElement  = hamSubCategoryNavTemplate(i);
        $('[data-id=ham-'+ i +']').closest('.ham-drop-wrap').append(itemSubCategoriesNavElement);
        
        for (let j = 0; j < data[i].subcategories.length; j++) {
            
            let itemSubcategoryElement = subCategoryItemTemplate('sub-category',
                    data[i].subcategories[j].img_src,
                    data[i].subcategories[j].item_title,
                    data[i].subcategories[j].href,
                    ''
                    );
            
            $('#ham-' + i).append(itemSubcategoryElement);
        };       
        
        
    };
    
    

    
}


//Header subcategories open on tap (instead of hover) only on touch/mobile devices
$('body').on('touchstart', '.sports-nav .head-drop-wrap.closed > a', function (e) {
    e.preventDefault();
    //console.log( 'Touch detected', e, $( this ).text() );
    let dialogNavHtml = basicModalTemplate('top-nav');
    if ($('dialog#top-nav').length == 0) {
        $('body').append(dialogNavHtml);
    }
    ;
    $('dialog#top-nav .modal-body').append($('nav#' + $(this).attr('data-id')).clone());
    $('dialog#top-nav .close-button').addClass('clear');
    $('dialog#top-nav')[0].showModal();
});  


//Header Hamburger Naviation for touchscreens / mobile devices
$('body').on('touchstart', '.ham-sports-nav .ham-drop-wrap.closed > a', function (e) {
    e.preventDefault();
    $('.ham-drop-wrap.open').toggleClass('closed open');
    $(this).closest('.ham-drop-wrap.closed').toggleClass('closed open');
    $('.hamburger-nav.open').toggleClass('subcategories-shown');
    
});
$('body').on('click', '.hamburger-nav.subcategories-shown .back-button', function (e) {
    e.preventDefault();
    $('.ham-drop-wrap.open').toggleClass('closed open');
    $('.hamburger-nav.subcategories-shown').toggleClass('subcategories-shown');    
});

